//@ts-check
import { mediaQuery } from "./mediaQuery"

export function updateTheme(savedTheme) {
  let theme = "system"
  try {
    if (!savedTheme) {
      savedTheme = window.localStorage.theme
    }
    if (savedTheme === "dark") {
      theme = "dark"
      document.documentElement.classList.add("dark")
    } else if (savedTheme === "light") {
      theme = "light"
      document.documentElement.classList.remove("dark")
    } else if (mediaQuery.matches) {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
  } catch {
    theme = "light"
    document.documentElement.classList.remove("dark")
  }
  return theme
}
